import type { IconData } from '@stacksjs/iconify-core'

export const sadFaceSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5S1.5 36.426 1.5 24M17 17a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0zm16-2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0v-2a2 2 0 0 0-2-2M18 35a6 6 0 0 1 12 0a2 2 0 1 0 4 0c0-5.523-4.477-10-10-10s-10 4.477-10 10a2 2 0 1 0 4 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sadFaceSolid
